/**
 * Selector to get whether the job start at dialog is open
 * @param {Object} state - Redux state object
 * @returns {boolean} True if the dialog is open, false otherwise
 */
export const getJobStartAtDialogOpen = (state) => {
  return state?.jobStartAtDialog?.open || false;
};
